<div class="flex">
  <span class="caption">{{ inputRole.name }}</span>
  <button type="button" class="button-reset" [attr.aria-label]="removeLabel" (click)="onRemoveRole($event)">
    <mat-icon>close</mat-icon>
  </button>
</div>
@if (isRemovingRole) {
  <mat-progress-bar mode="indeterminate" color="accent" class="progress-bar"></mat-progress-bar>
}
